enum ConfirmActionType {
  POSITIVE = 'action',
  PRIMARY = 'primary',
  NEGATIVE = 'negative',
  INFO = 'secondary',
  WARNING = 'warning',
}

export default ConfirmActionType;
